'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListTypeSelector = require('./components/ListTypeSelector.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListTypeSelector).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-type-selector/index.js
// module id = 1046
// module chunks = 0